document.addEventListener('DOMContentLoaded', function () {
  // Get the product "is new" status from the predefined variable
  const isNew = isProductNew === 'true'; // `isProductNew` comes from the theme script
  
  console.log("isProductNew:", isProductNew);

  // Initialize the "Leer más" modal
  const uniquePopupButton = document.getElementById('uniquePopupButton');
  const uniqueCloseModal = document.getElementById('uniqueCloseModal');
  const uniqueModal = document.getElementById('uniqueModal');
  const uniqueModalContent = document.getElementById('uniqueModalContent');

  if (uniquePopupButton && uniqueModal && uniqueCloseModal) {
    uniquePopupButton.addEventListener('click', function () {
      uniqueModal.style.display = 'block';

      // Use the `metafieldHTML` variable to populate modal content
      if (metafieldHTML) {
        uniqueModalContent.innerHTML = metafieldHTML;
      } else {
        uniqueModalContent.innerHTML = "<p>Content not available</p>";
      }
    });

    uniqueCloseModal.addEventListener('click', function () {
      uniqueModal.style.display = 'none';
    });

    window.addEventListener('click', function (event) {
      if (event.target === uniqueModal) {
        uniqueModal.style.display = 'none';
      }
    });
  } else {
    console.warn("Elements for 'Leer más' modal are missing.");
  }
  
  // Select the Semi-Nueva section container
  const semiNuevaSection = document.getElementById('semiNuevaSection');

  // Check the "is new" status and hide the section if necessary
  if (semiNuevaSection && isProductNew === 'true') {
    semiNuevaSection.style.display = 'none';
    console.log("'Certificada Semi-Nueva' section is hidden because the product is marked as new.");
  } else if (semiNuevaSection) {
    console.log("'Certificada Semi-Nueva' section is displayed.");
  } else {
    console.warn("'Certificada Semi-Nueva' section not found.");
  }
  

  // Payment Plans Modal
  const paymentModalButton = document.getElementById('paymentModalButton');
  const paymentCloseModal = document.getElementById('paymentCloseModal');
  const paymentPlansModal = document.getElementById('paymentPlansModal');

  if (paymentModalButton && paymentCloseModal && paymentPlansModal) {
    paymentModalButton.addEventListener('click', function () {
      paymentPlansModal.style.display = 'block';
    });

    paymentCloseModal.addEventListener('click', function () {
      paymentPlansModal.style.display = 'none';
    });

    window.addEventListener('click', function (event) {
      if (event.target === paymentPlansModal) {
        paymentPlansModal.style.display = 'none';
      }
    });
  }

  // Update Modal Content Function
  /* 2026-08-24: se elimino updateModalContent() -- calculaba 30% de enganche y 35% anual,
     terminos que ya no aplican (confirmado por Mario). Escribia en #downPaymentText y
     #monthlyPaymentText, elementos que ya no existen en la pagina. La mensualidad vigente
     (15% a 12 meses, Atrato Pago o tarjeta) vive en el bloque MOVO NOVO - MENSUALIDAD. */

  // Function to calculate and display the selling price
  function calculateSellingPrice(price) {
    const sellingPriceElement = document.getElementById('sellingPrice');
    if (!isNaN(price) && price > 0) {
      const sellingPrice = price / 0.6; // Calculate selling price
      if (sellingPriceElement) {
        sellingPriceElement.textContent = `$${sellingPrice.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      }
    } else if (sellingPriceElement) {
      sellingPriceElement.textContent = ` `; // Default value
    }
  }

  // Call the functions
  calculateSellingPrice(productPrice);
});


/* ===== MOVO NOVO - MENSUALIDAD (inicio 2026-08-24) =====
   Regla de negocio (definida por Mario): mensualidad = precio de contado x 1.15 / 12,
   pagadera con Atrato Pago o tarjeta de cr&eacute;dito.
   Para cambiar los terminos, edita MOVO_RATE / MOVO_MONTHS aqui abajo.
*/
(function () {
  var MOVO_RATE = 1.15;
  var MOVO_MONTHS = 12;
  var MOVO_MIN_PRICE = 10000;

  function parsePrice(txt) {
    if (!txt) return 0;
    var m = String(txt).replace(/[^0-9.,]/g, '');
    if (!m) return 0;
    m = m.replace(/,/g, '');
    var v = parseFloat(m);
    return isFinite(v) ? v : 0;
  }
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function monthly(p) { return p * MOVO_RATE / MOVO_MONTHS; }
  function financed(p) { return p * MOVO_RATE; }

  /* ---- pagina de producto ---- */
  function renderProduct() {
    var priceEl = document.querySelector('.product-block--price .product__price');
    if (!priceEl) return;
    var price = parsePrice(priceEl.textContent);
    var node = priceEl.parentElement.querySelector('.movo-monthly');
    if (price < MOVO_MIN_PRICE) { if (node) node.parentNode.removeChild(node); return; }
    if (!node) {
      node = document.createElement('div');
      node.className = 'movo-monthly';
      if (priceEl.insertAdjacentElement) { priceEl.insertAdjacentElement('afterend', node); }
      else { priceEl.parentNode.insertBefore(node, priceEl.nextSibling); }
    }
    var html = '<span class="movo-monthly__amount">' + fmt(monthly(price)) +
      '<span class="movo-monthly__per">/mes</span></span>' +
      '<span class="movo-monthly__terms">' + MOVO_MONTHS +
      ' meses con Atrato Pago o tarjeta de cr&eacute;dito &middot; total financiado ' +
      fmt(financed(price)) + '</span>';
    if (node.innerHTML !== html) { node.innerHTML = html; }
  }

  /* ---- tarjetas de coleccion ---- */
  function cardPrice(el) {
    var i, n, v = 0;
    for (i = 0; i < el.childNodes.length; i++) {
      n = el.childNodes[i];
      if (n.nodeType === 3) { v = parsePrice(n.nodeValue); if (v) return v; }
    }
    var spans = el.querySelectorAll('span');
    for (i = spans.length - 1; i >= 0; i--) {
      if (spans[i].className.indexOf('movo') === -1) {
        v = parsePrice(spans[i].textContent);
        if (v) return v;
      }
    }
    return 0;
  }
  function renderCards() {
    var list = document.querySelectorAll('.grid-product__price');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var mini = el.querySelector('.movo-monthly-mini');
      var price = cardPrice(el);
      if (price < MOVO_MIN_PRICE) { if (mini) mini.parentNode.removeChild(mini); continue; }
      if (!mini) {
        mini = document.createElement('div');
        mini.className = 'movo-monthly-mini';
        el.appendChild(mini);
      }
      var t = 'o ' + fmt(monthly(price)) + '/mes';
      if (mini.textContent !== t) { mini.textContent = t; }
    }
  }

  /* ---- tarjetas del filtro Globo / Shopify Product Filter (coleccion bicicletas) ---- */
  function renderSpf() {
    var list = document.querySelectorAll('.spf-product-card__price-wrapper');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var cur = el.querySelector('.spf-product-card__price');
      var price = 0;
      if (cur) { price = parsePrice(cur.textContent); }
      else { price = cardPrice(el); }
      var mini = el.querySelector('.movo-monthly-mini');
      if (price < MOVO_MIN_PRICE) { if (mini) mini.parentNode.removeChild(mini); continue; }
      if (!mini) {
        mini = document.createElement('div');
        mini.className = 'movo-monthly-mini';
        el.appendChild(mini);
      }
      var t = 'o ' + fmt(monthly(price)) + '/mes';
      if (mini.textContent !== t) { mini.textContent = t; }
    }
  }

  var busy = false;
  function renderAll() {
    if (busy) return;
    busy = true;
    try { renderProduct(); renderCards(); renderSpf(); } catch (e) {}
    setTimeout(function () { busy = false; }, 0);
  }

  function boot() {
    renderAll();
    var block = document.querySelector('.product-block--price');
    if (block && window.MutationObserver) {
      new MutationObserver(renderAll).observe(block, { childList: true, subtree: true, characterData: true });
    }
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            var n = muts[i].addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.className && String(n.className).indexOf('movo-monthly') !== -1) continue;
            var hit = n.querySelector && (n.querySelector('.grid-product__price') || n.querySelector('.spf-product-card__price-wrapper'));
            var self = n.classList && (n.classList.contains('grid-product__price') || n.classList.contains('spf-product-card__price-wrapper'));
            if (hit || self) {
              clearTimeout(t);
              t = setTimeout(renderAll, 60);
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { setTimeout(renderAll, 60); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
/* ===== MOVO NOVO - MENSUALIDAD (fin) ===== */


/* ===== MOVO NOVO - CONDICION: barras por componente (inicio 2026-08-24) =====
   El metafield condicion.tabla_check_html es una tabla HTML, asi que Liquid no
   puede leer los numeros por separado. Este bloque toma esa tabla ya renderizada
   y la convierte en filas con barra. Si algo falla, queda la tabla original
   (estilada por CSS) -- degrada sin romperse. */
(function () {
  function build() {
    var hosts = document.querySelectorAll('[data-movo-bars]');
    for (var h = 0; h < hosts.length; h++) {
      var host = hosts[h];
      if (host.getAttribute('data-movo-bars-done')) continue;
      var rows = host.querySelectorAll('tbody tr');
      if (!rows.length) continue;
      var frag = document.createDocumentFragment();
      var made = 0;
      for (var i = 0; i < rows.length; i++) {
        var cells = rows[i].querySelectorAll('td');
        if (cells.length < 2) continue;
        var name = cells[0].textContent.trim();
        var raw = cells[1].textContent.trim().replace(',', '.');
        var val = parseFloat(raw);
        if (!name || !isFinite(val)) continue;
        var pct = Math.max(0, Math.min(100, val * 10));
        var row = document.createElement('div');
        row.className = 'movo-cond__row';
        var left = document.createElement('div');
        var label = document.createElement('span');
        label.className = 'movo-cond__part';
        label.textContent = name;
        var bar = document.createElement('span');
        bar.className = 'movo-cond__bar';
        var fill = document.createElement('i');
        fill.style.width = pct.toFixed(1) + '%';
        bar.appendChild(fill);
        left.appendChild(label);
        left.appendChild(bar);
        var v = document.createElement('div');
        v.className = 'movo-cond__val';
        v.textContent = raw;
        row.appendChild(left);
        row.appendChild(v);
        frag.appendChild(row);
        made++;
      }
      if (!made) continue;
      host.innerHTML = '';
      host.appendChild(frag);
      host.setAttribute('data-movo-bars-done', '1');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(build, 60); });
})();
/* ===== MOVO NOVO - CONDICION: barras por componente (fin) ===== */


/* ===== MOVO NOVO - RESENAS: titulo en espanol (inicio 2026-08-24) =====
   El carrusel de tarjetas de Judge.me trae el titulo en ingles ("Customers are saying")
   porque viene de una configuracion del app (cards_carousel_title). Esto lo traduce
   en el front mientras se cambie en Judge.me. Cuando se corrija alla, este bloque se
   puede borrar sin efecto. */
(function () {
  var TXT = 'Lo que dicen nuestros clientes';
  var tries = 0;
  function fix() {
    var t = document.querySelectorAll('.jdgm-cards-carousel .jdgm-title, .jdgm-testimonials-carousel .jdgm-title, .jdgm-videos-carousel .jdgm-title');
    var done = false;
    for (var i = 0; i < t.length; i++) {
      if (/customers are saying/i.test(t[i].textContent)) { t[i].textContent = TXT; done = true; }
      else if (t[i].textContent.trim() === TXT) { done = true; }
    }
    if (!done && tries++ < 20) { setTimeout(fix, 400); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fix); } else { fix(); }
})();
/* ===== MOVO NOVO - RESENAS (fin) ===== */


/* ===== MOVO NOVO - APARTAR CON DEPOSITO (v2, 2026-09-01) =====
   Requisito de contabilidad de Mario: el deposito y la compra final tienen que
   quedar en EL MISMO pedido. Por eso no se usa un producto de deposito aparte
   (eso generaba dos pedidos), sino un selling plan de pago diferido de Shopify:
   se agrega LA BICI al carrito con selling_plan, el checkout cobra $3,000 y el
   saldo queda pendiente en el mismo pedido, a cobrar al preparar el pedido.

   El id del plan lo inyecta theme.liquid como movoSellingPlanId, y solo trae
   valor si ESE producto tiene el plan asignado. Si no lo tiene, el boton no se
   dibuja -- asi nunca aparece un boton que fallaria al hacer clic. */
(function () {
  var MOVO_DEPOSITO_MONTO = 3000;
  var MOVO_MIN = 10000;

  function planId() {
    /* theme.liquid lo declara con const: en un script clasico eso NO crea
       window.movoSellingPlanId, solo un binding lexico global. Por eso se lee
       el identificador pelon con guarda de typeof. */
    var v = '';
    try { if (typeof movoSellingPlanId === 'string') { v = movoSellingPlanId.trim(); } } catch (e) { v = ''; }
    var n = parseInt(v, 10);
    return isFinite(n) && n > 0 ? n : 0;
  }
  function parsePrice(txt) {
    if (!txt) return 0;
    var m = String(txt).replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var v = parseFloat(m);
    return isFinite(v) ? v : 0;
  }
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  function varianteActual() {
    var i = document.querySelector('.product-single__meta form[action*="/cart/add"] input[name="id"], .product-single__meta form[action*="/cart/add"] select[name="id"]');
    if (!i) { return 0; }
    var n = parseInt(i.value, 10);
    return isFinite(n) ? n : 0;
  }

  function apartar(btn) {
    if (window.movoTrack) { window.movoTrack('click', 'ficha'); }
    var variante = varianteActual();
    var plan = planId();
    if (!variante || !plan) { return fallo(btn); }
    btn.disabled = true;
    var original = btn.innerHTML;
    btn.innerHTML = 'Apartando...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      /* La propiedad de linea marca el pedido como apartado de forma inequivoca:
         vive solo en la linea creada por este boton y se ve en el admin. */
      body: JSON.stringify({ items: [{ id: variante, quantity: 1, selling_plan: plan,
        properties: (function () { var p = { 'Apartado': '5 dias - deposito $3,000' }; var c = window.movoCondicion ? window.movoCondicion(typeof sec !== 'undefined' ? sec : document) : ''; if (c) { p['Condición'] = c; } return p; })() }] })
    }).then(function (r) {
      if (!r.ok) { throw new Error('cart ' + r.status); }
      (window.movoSyncApartado ? window.movoSyncApartado() : Promise.resolve())
        .then(function () { window.location.href = '/checkout'; });
    }).catch(function () {
      btn.disabled = false;
      btn.innerHTML = original;
      fallo(btn);
    });
  }
  function fallo(btn) {
    var err = document.querySelector('.movo-apartar__error');
    if (err) { err.style.display = 'block'; }
  }

  function render() {
    if (!planId()) { return; }
    var precioEl = document.querySelector('.product-block--price .product__price');
    if (!precioEl) { return; }
    if (parsePrice(precioEl.textContent) < MOVO_MIN) { return; }
    var anchor = document.querySelector('.product-single__meta form[action*="/cart/add"]');
    if (!anchor) { return; }
    var host = anchor.closest('.product-block') || anchor.parentElement;
    if (!host || host.querySelector('.movo-apartar')) { return; }

    var box = document.createElement('div');
    box.className = 'movo-apartar';
    box.innerHTML =
      '<button type="button" class="movo-apartar__btn">Ap&aacute;rtala para venir a verla &middot; ' + fmt(MOVO_DEPOSITO_MONTO) + '</button>' +
      '<p class="movo-apartar__note">Con ' + fmt(MOVO_DEPOSITO_MONTO) + ' te la guardamos <strong>5 d&iacute;as</strong> a tu nombre para que vengas a probarla sin prisa.</p>' +
      '<p class="movo-apartar__error">No se pudo apartar. Int&eacute;ntalo de nuevo o escr&iacute;benos por WhatsApp.</p>';
    /* El apartado va ARRIBA de Agregar al carrito y Comprar ahora. Ojo: vive
       en otro contenedor que .payment-buttons, asi que hay que reubicarlo, no
       basta con reordenar. Si no hay ancla, cae al final como antes. */
    var pbF = host.querySelector('.payment-buttons') ||
              document.querySelector('.product-single__meta .payment-buttons');
    if (pbF && pbF.parentNode) { pbF.parentNode.insertBefore(box, pbF); }
    else { host.appendChild(box); }
    if (window.movoTrack) { window.movoTrack('visto', 'ficha'); }
    box.querySelector('.movo-apartar__btn').addEventListener('click', function () { apartar(this); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', render); }
  else { render(); }
  document.addEventListener('shopify:section:load', function () { setTimeout(render, 60); });
})();


/* ===== MOVO NOVO - NOMBRES DE SUCURSAL (inicio 2026-08-24) =====
   En Shopify las ubicaciones se llaman "Mario Pani" y "Valladolid"; de cara al
   cliente las sucursales son "Santa Fe" y "Roma". Esto solo cambia el texto en
   la tienda -- el checkout y el admin siguen usando el nombre real. Si algun dia
   se renombran las ubicaciones en Shopify, este bloque se puede borrar. */
(function () {
  var MAPA = [
    ['Mario Pani', 'Santa Fe'],
    ['Valladolid', 'Roma']
  ];
  var SEL = '.store-availability-container, .store-availabilities-list, .store-availability-information, [class*="store-availability"]';

  function walk(root) {
    if (!root) return;
    var it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n, cambios = 0;
    while ((n = it.nextNode())) {
      var v = n.nodeValue;
      if (!v || !v.trim()) continue;
      var nuevo = v;
      for (var i = 0; i < MAPA.length; i++) {
        if (nuevo.indexOf(MAPA[i][0]) !== -1) { nuevo = nuevo.split(MAPA[i][0]).join(MAPA[i][1]); }
      }
      if (nuevo !== v) { n.nodeValue = nuevo; cambios++; }
    }
    return cambios;
  }

  function run() {
    var hosts = document.querySelectorAll(SEL);
    for (var i = 0; i < hosts.length; i++) { walk(hosts[i]); }
  }

  function boot() {
    run();
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 80); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
/* ===== MOVO NOVO - NOMBRES DE SUCURSAL (fin) ===== */


/* ===== MOVO NOVO - EXTRAS QA (2026-09-06) ===== */

/* --- a) Ocultar bloques de "Mas Info" que vienen vacios ---------------------
   "Historia de la bici" sale del metafield datos_generales.historia. Cuando el
   producto no tiene historia, la seccion igual pinta icono y titulo con el
   cuerpo vacio. El titulo y el icono los dibuja la seccion FUERA del campo de
   texto, asi que un {% if %} dentro del texto no los alcanza: hay que ocultar
   el bloque completo desde aqui. */
(function () {
  function limpiar() {
    var bloques = document.querySelectorAll('.text-with-icons__block');
    for (var i = 0; i < bloques.length; i++) {
      var b = bloques[i];
      if (b.getAttribute('data-movo-check')) { continue; }
      var cuerpo = b.querySelector('.text-with-icons__block-text');
      if (!cuerpo) { continue; }
      var txt = (cuerpo.textContent || '').replace(/\s|\u00a0/g, '');
      if (txt === '') { b.style.display = 'none'; }
      b.setAttribute('data-movo-check', '1');
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', limpiar); }
  else { limpiar(); }
  document.addEventListener('shopify:section:load', function () { setTimeout(limpiar, 60); });
})();

/* --- b) Distintivo de bici nueva en la pagina de producto -------------------
   Habia una funcion a medio construir (new_pill.css cargado, new_pill.js nunca
   cargado, contenedor solo en la plantilla de accesorios, etiqueta en ingles).
   Esta la reemplaza usando el global isProductNew que ya inyecta theme.liquid. */
(function () {
  function esNueva() {
    try { return typeof isProductNew === 'string' && isProductNew.trim() === 'true'; }
    catch (e) { return false; }
  }
  function poner() {
    if (!esNueva()) { return; }
    var titulo = document.querySelector('.product-single__meta .product-single__title');
    if (!titulo || document.querySelector('.movo-nueva')) { return; }
    var b = document.createElement('span');
    b.className = 'movo-nueva';
    b.textContent = 'Nueva · garantía de fábrica';
    titulo.parentNode.insertBefore(b, titulo);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', poner); }
  else { poner(); }
  document.addEventListener('shopify:section:load', function () { setTimeout(poner, 60); });
})();

/* --- c) Aviso en el carrito de cuanto se paga hoy ---------------------------
   El carrito muestra el precio completo de la bici; el desglose del deposito
   aparece hasta el checkout. Quien llegue al carrito por el icono veria $69,990
   justo despues de decidir apartar. */
(function () {
  if (window.location.pathname.indexOf('/cart') !== 0) { return; }
  function avisar() {
    if (document.querySelector('.movo-cart-aviso')) { return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var hay = false;
        for (var i = 0; i < c.items.length; i++) {
          var sp = c.items[i].selling_plan_allocation;
          if (sp && sp.selling_plan && /Apartar/i.test(sp.selling_plan.name)) { hay = true; }
        }
        if (!hay) { return; }
        var ancla = document.querySelector('.cart__item-sub, .cart__footer, .cart-subtotal, [class*="cart__footer"]');
        if (!ancla) { return; }
        var p = document.createElement('p');
        p.className = 'movo-cart-aviso';
        p.innerHTML = 'Hoy pagas <strong>$3,000</strong>. El resto lo cubres al recoger la bici.';
        ancla.insertBefore(p, ancla.firstChild);
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', avisar); }
  else { avisar(); }
})();
/* ===== MOVO NOVO - EXTRAS QA (fin) ===== */

/* ===================== MOVO NOVO - QUE INCLUYE ===================== */
(function () {
  function esNueva() {
    try { if (typeof isProductNew !== "undefined") { return String(isProductNew) === "true"; } } catch (e) {}
    try { if (window.isProductNew) { return String(window.isProductNew) === "true"; } } catch (e) {}
    return false;
  }
  function run() {
    var wraps = document.querySelectorAll(".text-with-icons__block-text");
    if (!wraps.length) { return; }
    var nueva = esNueva();
    for (var i = 0; i < wraps.length; i++) {
      var ps = wraps[i].querySelectorAll("p");
      for (var j = 0; j < ps.length; j++) {
        var p = ps[j];
        var t = (p.textContent || "").replace(/\s+/g, " ").trim();
        if (t.indexOf("Accesorios:") === 0) {
          if (t.replace("Accesorios:", "").trim() === "") { p.style.display = "none"; }
        } else if (nueva && t.indexOf("d\u00edas de garant\u00eda") > -1) {
          p.innerHTML = "<strong>Garant\u00eda de f\u00e1brica</strong> del fabricante.";
        }
      }
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else { run(); }
})();

/* ================= MOVO NOVO - BADGE NUEVA EN CARDS ================= */
/* El app de filtros (Globo) re-renderiza la grid y borra el badge de Liquid.
   Aqui lo re-inyectamos usando los handles de la coleccion bicis-nuevas. */
(function () {
  var KEY = "movoNuevasHandles";
  var handles = null;
  var pidiendo = false;
  var pend = null;

  function apply() {
    if (!handles) { return; }
    var cards = document.querySelectorAll(".spf-product-card, .grid-product__content");
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.getAttribute("data-movo-nueva")) { continue; }
      var a = c.querySelector("a[href*='/products/']");
      if (!a) { continue; }
      var m = (a.getAttribute("href") || "").match(/\/products\/([^?#\/]+)/);
      if (!m) { continue; }
      c.setAttribute("data-movo-nueva", "1");
      if (handles.indexOf(m[1]) === -1) { continue; }
      if (c.querySelector(".movo-nueva-card")) { continue; }
      var t = c.querySelector(".spf-product-card__title, .grid-product__title");
      if (!t || !t.parentNode) { continue; }
      var s = document.createElement("span");
      s.className = "movo-nueva-card";
      s.textContent = "Nueva";
      t.parentNode.insertBefore(s, t);
    }
  }

  function pedir() {
    if (pidiendo) { return; }
    pidiendo = true;
    var cache = null;
    try { cache = sessionStorage.getItem(KEY); } catch (e) {}
    if (cache) {
      try { handles = JSON.parse(cache); apply(); return; } catch (e) {}
    }
    fetch("/collections/bicis-nuevas/products.json?limit=250")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        handles = (d.products || []).map(function (p) { return p.handle; });
        try { sessionStorage.setItem(KEY, JSON.stringify(handles)); } catch (e) {}
        apply();
      })
      .catch(function () { handles = []; });
  }

  function check() {
    if (!document.querySelector(".spf-product-card, .grid-product__content")) { return; }
    if (handles) { apply(); } else { pedir(); }
  }

  function init() {
    check();
    if (!window.MutationObserver) { return; }
    var mo = new MutationObserver(function () {
      if (pend) { clearTimeout(pend); }
      pend = setTimeout(check, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();

/* ================= MOVO NOVO - APARTAR DESDE EL CARRITO ================= */
/* Ofrece cambiar la linea al plan de apartado ($3,000) justo arriba de
   "Finalizar pedido", en el drawer y en /cart. Usa /cart/change.js con
   selling_plan, que aplica y quita el plan sobre la MISMA linea: un solo
   pedido, como lo necesita contabilidad.
   Probado: aplicar el plan NO cambia el total del carrito; el desglose
   "vence hoy $3,000 / al preparar $64,990" aparece hasta el checkout,
   por eso el bloque lo dice explicitamente.
   La propiedad "Apartado" es uno de los tres candados del Flow: sin ella
   el flujo de correos no dispara. */
(function () {
  var GRUPO = "Apartar";
  var DEPOSITO = 300000;
  var PROP = { "Apartado": "5 dias - deposito $3,000" };
  var MIN = DEPOSITO * 2;
  var cacheProd = {};
  var trabajando = false;
  var pend = null;

  function money(c) { return "$" + Math.round(c / 100).toLocaleString("es-MX"); }
  function getCart() { return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }); }
  function getProd(h) {
    if (cacheProd[h] !== undefined) { return Promise.resolve(cacheProd[h]); }
    return fetch("/products/" + h + ".js").then(function (r) { return r.json(); })
      .then(function (p) { cacheProd[h] = p; return p; })
      .catch(function () { cacheProd[h] = null; return null; });
  }
  function planDe(p) {
    var g = (p && p.selling_plan_groups) || [];
    for (var i = 0; i < g.length; i++) {
      if ((g[i].name || "").indexOf(GRUPO) > -1 && g[i].selling_plans && g[i].selling_plans.length) {
        return g[i].selling_plans[0].id;
      }
    }
    return null;
  }
  function bonoDe(p, variantId, planId) {
    var vs = (p && p.variants) || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].id !== variantId) { continue; }
      var as = vs[i].selling_plan_allocations || [];
      for (var j = 0; j < as.length; j++) {
        if (as[j].selling_plan_id === planId) {
          return Math.max(0, (as[j].compare_at_price || 0) - (as[j].price || 0));
        }
      }
    }
    return 0;
  }
  function tienePlan(it) {
    var a = it.selling_plan_allocation;
    return !!(a && a.selling_plan && (a.selling_plan.name || "").indexOf(GRUPO) > -1);
  }

  function bloque(info) {
    var it = info.item, resto = it.line_price - DEPOSITO;
    var bono = info.bono || 0;
    var ahorro = DEPOSITO + bono;
    var n = document.createElement("div");
    n.className = "movo-apc" + (info.apartada ? " movo-apc--on" : "");
    n.innerHTML = info.apartada
      ? "<p class='movo-apc__t'>Vas a apartar esta bici</p>"
        + "<p class='movo-apc__d'>Hoy pagas <b>" + money(DEPOSITO) + "</b> y el resto, <b>" + money(resto)
        + "</b>, cuando preparemos tu pedido. Te la guardamos <b>5 d&iacute;as</b> a tu nombre para que vengas a verla."
        + (bono > 0 ? " Ya te aplicamos los <b>" + money(bono) + " de regalo</b>." : "")
        + " Los " + money(DEPOSITO) + " se aplican a tu compra y no se devuelven.</p>"
        + "<p class='movo-apc__nota'>El total de aqu&iacute; arriba muestra el precio completo de la bici. "
        + "El desglose de lo que pagas hoy aparece en la pantalla de pago.</p>"
        + "<button type='button' class='movo-apc__btn movo-apc__btn--ghost'>Mejor pagarla completa</button>"
        + "<p class='movo-apc__error'>No se pudo cambiar. Int&eacute;ntalo de nuevo.</p>"
      : "<p class='movo-apc__t'>Ap&aacute;rtala con " + money(DEPOSITO) + " y ven a verla</p>"
        + "<p class='movo-apc__d'>Te la guardamos <b>5 d&iacute;as</b> a tu nombre para que vengas a probarla sin prisa"
        + (bono > 0
            ? ", y te regalamos <b>" + money(bono) + "</b>: al recogerla pagas <b>" + money(ahorro) + " menos</b>. "
            : ". ")
        + "El resto lo pagas cuando la recojas. Los " + money(DEPOSITO) + " se aplican a tu compra y no se devuelven.</p>"
        + "<button type='button' class='movo-apc__btn'>Apartar con " + money(DEPOSITO) + "</button>"
        + "<p class='movo-apc__error'>No se pudo apartar. Int&eacute;ntalo de nuevo.</p>";
    n.querySelector(".movo-apc__btn").addEventListener("click", function () {
      /* el mismo bloque vive en /cart y en el drawer: hay que distinguirlos */
      if (window.movoTrack && !info.apartada) {
        window.movoTrack('click', n.closest('#CartDrawer') ? 'drawer' : 'carrito');
      }
      cambiar(it.key, info.planId, !info.apartada, it.properties);
    });
    return n;
  }

  /* Conserva las propiedades que ya trae la linea (Condición, por ejemplo).
     OJO: /cart/change.js REEMPLAZA el objeto completo de propiedades, no lo
     mezcla. Mandar solo {Apartado} borraba todo lo demas en silencio. */
  function mezclaProps(props, aplicar) {
    var p = {};
    for (var k in (props || {})) {
      if (Object.prototype.hasOwnProperty.call(props, k) && k !== 'Apartado') { p[k] = props[k]; }
    }
    p['Apartado'] = aplicar ? PROP['Apartado'] : '';
    return p;
  }

  function cambiar(key, planId, aplicar, props) {
    if (trabajando) { return; }
    trabajando = true;
    var bs = document.querySelectorAll(".movo-apc__btn");
    for (var i = 0; i < bs.length; i++) { bs[i].disabled = true; bs[i].textContent = "Un momento..."; }
    return fetch("/cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 1, selling_plan: aplicar ? planId : "", properties: mezclaProps(props, aplicar) })
    }).then(function (r) {
      trabajando = false;
      if (!r.ok) { throw new Error(r.status); }
      if (window.movoSyncApartado) { window.movoSyncApartado(); }
      return pintar();
    }).catch(function () {
      trabajando = false;
      var es = document.querySelectorAll(".movo-apc__error");
      for (var j = 0; j < es.length; j++) { es[j].style.display = "block"; }
      var bb = document.querySelectorAll(".movo-apc__btn");
      for (var k = 0; k < bb.length; k++) { bb[k].disabled = false; }
    });
  }

  function pintar() {
    return getCart().then(function (cart) {
      var viejos = document.querySelectorAll(".movo-apc");
      for (var i = 0; i < viejos.length; i++) { viejos[i].remove(); }
      if (!cart.items.length) { return; }
      var cands = cart.items.filter(function (it) { return it.line_price >= MIN || tienePlan(it); });
      if (!cands.length) { return; }
      return Promise.all(cands.map(function (it) {
        if (tienePlan(it)) {
          var al = it.selling_plan_allocation;
          return { item: it, planId: al.selling_plan.id, apartada: true,
                   bono: Math.max(0, (al.compare_at_price || 0) - (al.price || 0)) };
        }
        return getProd(it.handle).then(function (p) {
          var id = planDe(p);
          return id ? { item: it, planId: id, apartada: false, bono: bonoDe(p, it.variant_id, id) } : null;
        });
      })).then(function (rs) {
        var ok = rs.filter(Boolean);
        if (ok.length !== 1) { return; }
        var cajas = document.querySelectorAll(".cart__checkout-wrapper");
        for (var j = 0; j < cajas.length; j++) {
          var nb = bloque(ok[0]);
          cajas[j].insertBefore(nb, cajas[j].firstChild);
          /* solo cuenta si de verdad se ve: en /cart se inyectan dos copias
             y la del drawer esta oculta. */
          if (window.movoTrack && !ok[0].apartada && nb.offsetParent !== null) {
            window.movoTrack('visto', nb.closest('#CartDrawer') ? 'drawer' : 'carrito');
          }
        }
        /* Shopify oculta los botones expres (PayPal, Shop Pay) para lineas con
           pago diferido, pero solo al recargar. Si el cliente aparta sin recargar,
           PayPal seguiria visible y no sabe manejar el deposito. Lo ocultamos ya. */
        var expres = document.querySelectorAll(".additional-checkout-buttons");
        for (var k = 0; k < expres.length; k++) {
          expres[k].style.display = ok[0].apartada ? "none" : "";
        }
      });
    }).catch(function () {});
  }

  function agenda() {
    if (pend) { clearTimeout(pend); }
    pend = setTimeout(function () {
      pend = null;
      if (!trabajando) { pintar(); }
    }, 250);
  }

  /* Un nodo 'mio' es el bloque de apartado o algo dentro de el. Hay que
     ignorarlo: pintar() borra y reinserta .movo-apc, y si el observer
     reacciona a eso se hace un bucle infinito. */
  function esMio(el) {
    return !!(el && el.nodeType === 1 &&
      (el.classList.contains('movo-apc') ||
       (el.closest && el.closest('.movo-apc'))));
  }
  function hayAjeno(lista) {
    for (var i = 0; i < lista.length; i++) {
      if (lista[i].nodeType === 1 && !esMio(lista[i])) { return true; }
    }
    return false;
  }

  /* OJO: no se puede esperar a que aparezca .cart__checkout-wrapper. Ese
     nodo ya esta en el DOM desde el page load (aun con el carrito vacio)
     y en un add por AJAX el tema solo reemplaza .cart__items. Medido en
     vivo: 4 mutaciones dentro del drawer, 0 que reinserten el wrapper.
     Por eso escuchamos los contenedores del carrito completos. */
  var SEL_CARRITO = '#CartDrawer, .drawer--cart, .cart__page, ' +
    '.cart__checkout-wrapper, .drawer__inner, .drawer__contents, ' +
    'form[action*="/cart"], [data-section-type="cart-drawer"]';

  function init() {
    pintar();

    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          /* Si lo unico que cambio es nuestro propio bloque, ignorar. */
          if (!hayAjeno(m.addedNodes) && !hayAjeno(m.removedNodes)) { continue; }
          var t = m.target;
          if (t && t.nodeType !== 1) { t = t.parentNode; }
          if (!t || !t.closest || esMio(t)) { continue; }
          /* a) cambio algo DENTRO del carrito o del drawer */
          if (t.closest(SEL_CARRITO)) { agenda(); return; }
          /* b) o aparecio el carrito/checkout en otra parte del DOM */
          for (var j = 0; j < m.addedNodes.length; j++) {
            var el = m.addedNodes[j];
            if (el.nodeType !== 1 || esMio(el)) { continue; }
            if (el.matches && el.matches(SEL_CARRITO)) { agenda(); return; }
            if (el.querySelector &&
                el.querySelector('.cart__checkout-wrapper, .cart__checkout')) {
              agenda(); return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    /* Eventos propios de Impulse / ajaxify, por si alguno llega antes que
       la mutacion del DOM. agenda() esta debounced: repetir no cuesta. */
    ['cart:updated', 'cart:build', 'cart:open', 'cart:refresh',
     'ajaxProduct:added', 'added.ajaxProduct'].forEach(function (ev) {
      document.addEventListener(ev, agenda);
    });
  }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); }
  else { init(); }
})();

/* ========== MOVO NOVO - COPY DEL APARTADO EN LA FICHA (bono dinamico) ========== */
/* El bono de $2,000 solo existe en las bicis arriba de $20,000 (grupo A).
   movoApartarBono viene de theme.liquid y vale 0 en las del grupo B, asi que
   nunca prometemos un regalo que esa bici no trae. */
(function () {
  function bono() {
    try { if (typeof movoApartarBono !== "undefined") { return parseInt(movoApartarBono, 10) || 0; } } catch (e) {}
    return 0;
  }
  function money(c) { return "$" + Math.round(c / 100).toLocaleString("es-MX"); }
  function run() {
    var caja = document.querySelector(".movo-apartar");
    if (!caja || caja.getAttribute("data-movo-copy")) { return; }
    var p = caja.querySelector("p");
    if (!p) { return; }
    caja.setAttribute("data-movo-copy", "1");
    var b = bono();
    var DEP = 300000;
    p.innerHTML = b > 0
      ? "Con <b>" + money(DEP) + "</b> te la guardamos <b>5 d&iacute;as</b> a tu nombre para que vengas a "
        + "probarla sin prisa. Adem&aacute;s te regalamos <b>" + money(b) + "</b> para tu compra: al recogerla "
        + "pagas <b>" + money(DEP + b) + " menos</b>."
      : "Con <b>" + money(DEP) + "</b> te la guardamos <b>5 d&iacute;as</b> a tu nombre para que vengas a "
        + "probarla sin prisa. Tus " + money(DEP) + " se descuentan del precio.";
  }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", run); }
  else { run(); }
  setTimeout(run, 1200);
})();

/* ================= MOVO NOVO - BONO VISIBLE ================= */
/* Hace evidente el regalo de $2,000 donde se decide: debajo del precio en la
   ficha, y en las tarjetas de coleccion. El monto sale de movoApartarBono
   (ficha) o del precio de la tarjeta, asi que nunca lo promete donde no existe.
   Honestidad: el titular es el descuento real ($2,000). El "pagas $5,000 menos"
   va como apoyo, porque $3,000 de esos son su propio deposito. */
(function () {
  var UMBRAL = 20000;   /* pesos: a partir de aqui aplica el bono */
  var BONO = 2000;
  var DEP = 3000;

  function fmt(n) { return "$" + Math.round(n).toLocaleString("es-MX"); }

  function bonoFicha() {
    try { if (typeof movoApartarBono !== "undefined") { return (parseInt(movoApartarBono, 10) || 0) / 100; } } catch (e) {}
    return 0;
  }

  /* ---- 1. Franja en la ficha de producto, debajo del precio ---- */
  function ficha() {
    var b = bonoFicha();
    if (!b) { return; }
    var ancla = document.querySelector(".movo-monthly");
    if (!ancla || document.querySelector(".movo-bono")) { return; }
    var n = document.createElement("div");
    n.className = "movo-bono";
    n.innerHTML =
      "<span class='movo-bono__big'>Te regalamos " + fmt(b) + " en tu compra</span>" +
      "<span class='movo-bono__sub'>Ap&aacute;rtala con " + fmt(DEP) + " y ven a verla sin prisa</span>";
    ancla.parentNode.insertBefore(n, ancla.nextSibling);
  }

  /* ---- 2. Linea en las tarjetas de coleccion ---- */
  function precioDe(el) {
    var c = el.cloneNode(true);
    var fuera = c.querySelectorAll("s, del, .visually-hidden, .icon, .movo-monthly-mini, .movo-bono-mini");
    for (var i = 0; i < fuera.length; i++) { fuera[i].remove(); }
    var t = (c.textContent || "").replace(/[^0-9.,]/g, " ").trim();
    var m = t.match(/[0-9][0-9.,]*/);
    if (!m) { return 0; }
    return parseFloat(m[0].replace(/,/g, "")) || 0;
  }

  function tarjetas() {
    var ps = document.querySelectorAll(".grid-product__price, .spf-product-card__price");
    for (var i = 0; i < ps.length; i++) {
      var el = ps[i];
      if (el.getAttribute("data-movo-bono")) { continue; }
      el.setAttribute("data-movo-bono", "1");
      if (precioDe(el) < UMBRAL) { continue; }
      var s = document.createElement("span");
      s.className = "movo-bono-mini";
      s.textContent = fmt(BONO) + " de regalo si la apartas";
      var destino = el.parentNode.querySelector(".movo-monthly-mini");
      if (destino) { destino.parentNode.insertBefore(s, destino.nextSibling); }
      else { el.parentNode.insertBefore(s, el.nextSibling); }
    }
  }

  var pend = null;
  function run() { ficha(); tarjetas(); }
  function agenda() { if (pend) { clearTimeout(pend); } pend = setTimeout(run, 200); }

  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", run); }
  else { run(); }
  setTimeout(run, 900);
  if (window.MutationObserver) {
    new MutationObserver(agenda).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ================= MOVO NOVO - ATRIBUTO DE APARTADO ================= */
/* Deja una marca a nivel CARRITO (-> atributo del pedido) cuando alguna linea
   trae el plan de apartado. Sirve para condicionar bloques del checkout y de
   la pagina de gracias en apps como Checkout Blocks, que suelen exponer los
   atributos del pedido pero no siempre las propiedades de linea.
   Se mantiene sola: si el cliente revierte a compra completa, se limpia. */
(function () {
  var GRUPO = "Apartar";
  var LLAVE = "Apartado";
  var LLAVE_BONO = "Bono";
  var enVuelo = false;

  function pesos(c) {
    return "$" + Math.round(c / 100).toLocaleString("es-MX");
  }

  /* Devuelve {hay, bono} de la linea apartada. El bono sale del propio
     selling plan (compare_at_price - price), no de una constante: asi las
     bicis sin bono (abajo de $20,000) nunca prometen el regalo. */
  function leerApartado(cart) {
    var its = (cart && cart.items) || [];
    for (var i = 0; i < its.length; i++) {
      var a = its[i].selling_plan_allocation;
      if (a && a.selling_plan && (a.selling_plan.name || "").indexOf(GRUPO) > -1) {
        var b = 0;
        if (a.compare_at_price && a.compare_at_price > a.price) {
          b = a.compare_at_price - a.price;
        }
        return { hay: true, bono: b };
      }
    }
    return { hay: false, bono: 0 };
  }

  /* Devuelve una promesa que SIEMPRE resuelve: nunca debe bloquear un checkout. */
  window.movoSyncApartado = function () {
    if (enVuelo) { return Promise.resolve(); }
    enVuelo = true;
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var info = leerApartado(cart);
        var deseado = info.hay ? "si" : "";
        var deseadoBono = (info.hay && info.bono > 0) ? pesos(info.bono) : "";
        var at = cart.attributes || {};
        if ((at[LLAVE] || "") === deseado &&
            (at[LLAVE_BONO] || "") === deseadoBono) { return null; }
        var attrs = {};
        attrs[LLAVE] = deseado;
        attrs[LLAVE_BONO] = deseadoBono;
        return fetch("/cart/update.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: attrs })
        });
      })
      .catch(function () { return null; })
      .then(function () { enVuelo = false; return null; });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { window.movoSyncApartado(); });
  } else { window.movoSyncApartado(); }
})();


/* ================= MOVO NOVO - APARTAR EN VISTA RAPIDA ================= */
/* El modal de vista rapida (quick shop) carga el section del producto por
   AJAX cuando el cliente pasa el mouse sobre la tarjeta, mucho despues de
   DOMContentLoaded. Por eso ninguno de los bloques de la ficha llega ahi
   (.movo-monthly, .movo-bono, .movo-apartar se inyectan una sola vez al
   cargar la pagina). Este bloque los replica DENTRO del modal.
   Comportamiento igual que la ficha: agrega con el plan y manda al checkout.
   Solo escritorio: el tema le pone small--hide al boton de vista rapida. */
(function () {
  var GRUPO = 'Apartar';
  var DEP = 3000;            /* pesos */
  var MIN = 6000;            /* pesos: el doble del deposito */
  var SEC = '.product-section[data-modal="true"][data-product-handle]';
  var cache = {};
  var pend = null;

  function pesos(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  function getProd(handle) {
    if (cache[handle] !== undefined) { return Promise.resolve(cache[handle]); }
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { cache[handle] = p; return p; })
      .catch(function () { cache[handle] = null; return null; });
  }

  function planDe(prod) {
    var gs = (prod && prod.selling_plan_groups) || [];
    for (var i = 0; i < gs.length; i++) {
      if ((gs[i].name || '').indexOf(GRUPO) > -1 && gs[i].selling_plans && gs[i].selling_plans.length) {
        return gs[i].selling_plans[0].id;
      }
    }
    return null;
  }

  /* Bono en pesos, leido del propio plan (compare_at_price - price). 0 si no
     aplica: asi las bicis de menos de $20,000 nunca prometen el regalo. */
  function bonoDe(prod, variantId, planId) {
    var vs = (prod && prod.variants) || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].id !== variantId) { continue; }
      var al = vs[i].selling_plan_allocations || [];
      for (var j = 0; j < al.length; j++) {
        if (al[j].selling_plan_id === planId && al[j].compare_at_price > al[j].price) {
          return (al[j].compare_at_price - al[j].price) / 100;
        }
      }
    }
    return 0;
  }

  function varianteDe(sec) {
    var i = sec.querySelector('form[action*="/cart/add"] input[name="id"], ' +
                              'form[action*="/cart/add"] select[name="id"]');
    if (!i) { return 0; }
    var n = parseInt(i.value, 10);
    return isFinite(n) ? n : 0;
  }
  function fallo(sec, btn) {
    btn.disabled = false;
    btn.textContent = 'Apártala para venir a verla · ' + pesos(DEP);
    var e = sec.querySelector('.movo-apartar__error');
    if (e) { e.style.display = 'block'; }
  }

  function apartar(sec, btn, planId) {
    if (window.movoTrack) { window.movoTrack('click', 'vista-rapida'); }
    var variante = varianteDe(sec);   /* se relee al hacer clic, por si cambio la talla */
    if (!variante || !planId) { return fallo(sec, btn); }
    btn.disabled = true;
    btn.textContent = 'Apartando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      /* La propiedad de linea marca el pedido como apartado de forma inequivoca. */
      body: JSON.stringify({ items: [{ id: variante, quantity: 1, selling_plan: planId,
        properties: (function () { var p = { 'Apartado': '5 dias - deposito $3,000' }; var c = window.movoCondicion ? window.movoCondicion(typeof sec !== 'undefined' ? sec : document) : ''; if (c) { p['Condición'] = c; } return p; })() }] })
    }).then(function (r) {
      if (!r.ok) { throw new Error('cart ' + r.status); }
      (window.movoSyncApartado ? window.movoSyncApartado() : Promise.resolve())
        .then(function () { window.location.href = '/checkout'; });
    }).catch(function () { fallo(sec, btn); });
  }

  function pintarSeccion(sec) {
    if (!sec || sec.getAttribute('data-movo-qv')) { return; }
    var handle = sec.getAttribute('data-product-handle');
    var form = sec.querySelector('form[action*="/cart/add"]');
    if (!handle || !form) { return; }
    sec.setAttribute('data-movo-qv', '1');   /* marcar ya: evita carreras */

    getProd(handle).then(function (p) {
      if (!p) { return; }
      var planId = planDe(p);
      var variante = varianteDe(sec);
      var precio = 0;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].id === variante) { precio = p.variants[i].price / 100; }
      }
      if (!planId || precio < MIN) { return; }
      var bono = bonoDe(p, variante, planId);

      /* 1) Franja del bono, debajo del precio */
      var pr = sec.querySelector('.product__price');
      if (bono > 0 && pr && !sec.querySelector('.movo-bono')) {
        var fr = document.createElement('div');
        fr.className = 'movo-bono';
        fr.innerHTML =
          '<span class="movo-bono__big">Te regalamos ' + pesos(bono) + ' en tu compra</span>' +
          '<span class="movo-bono__sub">Apártala con ' + pesos(DEP) + ' y ven a verla sin prisa</span>';
        pr.parentNode.insertBefore(fr, pr.nextSibling);
      }

      /* 2) Bloque de apartado, debajo de Agregar al carrito */
      var caja = document.createElement('div');
      caja.className = 'movo-apartar movo-apartar--qv';
      caja.innerHTML =
        '<button type="button" class="movo-apartar__btn">Apártala para venir a verla · ' + pesos(DEP) + '</button>' +
        '<p class="movo-apartar__note">Con <b>' + pesos(DEP) + '</b> te la guardamos <b>5 días</b> a tu nombre ' +
        'para que vengas a probarla sin prisa.' +
        (bono > 0
          ? ' Además te regalamos <b>' + pesos(bono) + '</b> para tu compra: al recogerla pagas <b>' + pesos(DEP + bono) + ' menos</b>.'
          : ' Tus ' + pesos(DEP) + ' se descuentan del precio.') +
        '</p>' +
        '<p class="movo-apartar__error">No se pudo apartar. Inténtalo de nuevo o escríbenos por WhatsApp.</p>';
      var pbQ = sec.querySelector('.payment-buttons');
      if (pbQ && pbQ.parentNode) { pbQ.parentNode.insertBefore(caja, pbQ); }
      else { form.parentNode.insertBefore(caja, form.nextSibling); }
      if (window.movoTrack) { window.movoTrack('visto', 'vista-rapida'); }

      caja.querySelector('.movo-apartar__btn').addEventListener('click', function () {
        apartar(sec, this, planId);
      });
    });
  }

  function barrer() {
    var secs = document.querySelectorAll(SEC);
    for (var i = 0; i < secs.length; i++) { pintarSeccion(secs[i]); }
  }

  function agenda() {
    if (pend) { clearTimeout(pend); }
    pend = setTimeout(function () { pend = null; barrer(); }, 200);
  }

  function init() {
    barrer();
    if (!window.MutationObserver) { return; }
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        var t = m.target;
        if (t && t.nodeType !== 1) { t = t.parentNode; }
        /* ignorar lo que nosotros mismos pintamos */
        if (t && t.closest && (t.closest('.movo-apartar') || t.closest('.movo-bono'))) { continue; }
        /* OJO: el form de compra NO existe cuando el modal precarga en hover;
           llega hasta que el modal se abre. Por eso hay que reaccionar a
           cualquier cambio DENTRO de la seccion, no solo a que aparezca. */
        if (t && t.closest && t.closest(SEC)) { agenda(); return; }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var el = m.addedNodes[j];
          if (el.nodeType !== 1) { continue; }
          if (el.classList.contains('movo-apartar') || el.classList.contains('movo-bono')) { continue; }
          if ((el.matches && el.matches(SEC)) ||
              (el.querySelector && el.querySelector(SEC))) { agenda(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    /* Red extra: al abrir la vista rapida el tema arma el form. barrer() es
       barato y pintarSeccion() se auto-bloquea con data-movo-qv. */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.quick-product__btn')) {
        setTimeout(barrer, 300);
        setTimeout(barrer, 900);
      }
    }, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();


/* ============ MOVO NOVO - PRUEBA SOCIAL EN EL BUY BOX ============ */
/* Hoy una bici de $260,000 no tiene ni una senal social junto al boton de
   comprar: escondimos el badge de "Sin resenas" de Judge.me y no pusimos
   nada en su lugar. La resena del PRODUCTO casi siempre es cero (cada bici
   seminueva es unica), asi que la senal util es la de la TIENDA.
   Los numeros salen de los metafields de Judge.me via theme.liquid: si
   manana hay 70 resenas, aqui dice 70. Nunca se hardcodean.
   Funciona igual en la ficha y en el modal de vista rapida. */
(function () {
  function datos() {
    var n = 0, r = 0;
    try { if (typeof movoResenasNum !== 'undefined') { n = parseInt(movoResenasNum, 10) || 0; } } catch (e) {}
    try { if (typeof movoResenasRating !== 'undefined') { r = parseFloat(movoResenasRating) || 0; } } catch (e) {}
    return { n: n, r: r };
  }

  function bloque(d) {
    var pct = Math.max(0, Math.min(100, (d.r / 5) * 100));
    var el = document.createElement('div');
    el.className = 'movo-social';
    el.setAttribute('data-movo-social', '1');
    el.innerHTML =
      '<span class="movo-social__stars" style="--movo-fill:' + pct.toFixed(1) + '%" aria-hidden="true">★★★★★</span>' +
      '<span class="movo-social__txt"><span class="movo-social__n">' + d.r.toFixed(2) + '</span> · ' +
      d.n + ' reseñas verificadas</span>' +
      '<span class="movo-social__src">Judge.me</span>';
    el.setAttribute('aria-label', d.r.toFixed(2) + ' de 5 estrellas, ' + d.n + ' reseñas verificadas');
    return el;
  }

  function pintar() {
    var d = datos();
    if (!d.n || !d.r) { return; }   /* sin datos reales no inventamos nada */
    var cajas = document.querySelectorAll('.payment-buttons');
    for (var i = 0; i < cajas.length; i++) {
      var c = cajas[i];
      if (c.getAttribute('data-movo-social')) { continue; }
      c.setAttribute('data-movo-social', '1');
      /* Si el apartado ya subio arriba de los botones, las estrellas van
         arriba de el: respaldan toda la caja de compra, no solo un boton. */
      var ancla = c.parentNode.querySelector('.movo-apartar') || c;
      c.parentNode.insertBefore(bloque(d), ancla);
    }
  }

  var pend = null;
  function agenda() { if (pend) { clearTimeout(pend); } pend = setTimeout(pintar, 200); }

  function init() {
    pintar();
    if (!window.MutationObserver) { return; }
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var el = muts[i].addedNodes[j];
          if (el.nodeType !== 1 || el.classList.contains('movo-social')) { continue; }
          if ((el.matches && el.matches('.payment-buttons')) ||
              (el.querySelector && el.querySelector('.payment-buttons'))) { agenda(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();

/* ====== MOVO NOVO - CONDICION EN EL RESUMEN (propiedad de linea) ====== */
/* Una bici seminueva es un producto de UNA sola pieza, no una talla M
   generica. En el carrito y el checkout salia solo el nombre y la foto.
   Metemos la calificacion de condicion como PROPIEDAD DE LINEA: Shopify la
   pinta sola bajo el nombre del producto en el carrito, en el checkout, en
   el correo de confirmacion y en el admin. Sin apps y sin tocar el checkout.
   Se inyecta como input oculto dentro del form, asi viaja igual si el tema
   agrega por AJAX o por submit normal. */
(function () {
  var LLAVE = 'Condición';

  function scoreDe(form) {
    /* OJO: sin fallback a document. Los widgets de productos relacionados
       (Globo, .spf-product__form) montan formularios de OTRAS bicis en esta
       misma pagina; con el fallback todos heredaban la calificacion de la
       bici principal y el pedido salia con el dato equivocado. */
    var raiz = form.closest && form.closest('.product-section');
    if (!raiz) { return ''; }
    var n = raiz.querySelector('.movo-cond__num');
    var s = n ? (n.textContent || '').trim() : '';
    return /^[0-9]+(\.[0-9]+)?$/.test(s) ? s : '';
  }

  /* Expuesto para que el boton de apartar mande la misma propiedad. */
  window.movoCondicion = function (raiz) {
    var r = raiz || document;
    var n = r.querySelector('.movo-cond__num');
    var s = n ? (n.textContent || '').trim() : '';
    return /^[0-9]+(\.[0-9]+)?$/.test(s) ? s + ' / 10' : '';
  };

  function pintar() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.getAttribute('data-movo-cond')) { continue; }
      var s = scoreDe(f);
      if (!s) { continue; }        /* accesorios y bicis sin calificacion: nada */
      f.setAttribute('data-movo-cond', '1');
      /* El nombre del mecanico viaja PEGADO a la calificacion, no como una
       propiedad aparte: en el checkout ya salen 4 renglones bajo el nombre
       del producto y un quinto se vuelve ruido. Juntos dicen mas que
       separados: un numero con autor es una persona que responde por el. */
      var raizMec = f.closest && f.closest('.product-section');
      var nm = raizMec ? raizMec.querySelector('.movo-cond__mec') : null;
      var mecanico = nm ? (nm.textContent || '').trim() : '';
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[' + LLAVE + ']';
      inp.value = s + ' / 10' + (mecanico ? ' \u00b7 revisada por ' + mecanico : '');
      f.appendChild(inp);

      /* Altura recomendada de la bici. Viaja junto a la condicion para que el
         taller pueda compararla contra la altura que el cliente declara en el
         checkout y cachar una talla equivocada ANTES de enviarla. Solo existe
         en el 77% de las bicis; si no hay dato, no se imprime. */
      var raizAlt = f.closest && f.closest('.product-section');
      var na = raizAlt ? raizAlt.querySelector('[data-movo-altura]') : null;
      var alt = na ? (na.getAttribute('data-movo-altura') || '').trim() : '';
      if (alt) {
        var ia = document.createElement('input');
        ia.type = 'hidden';
        ia.name = 'properties[Altura recomendada]';
        ia.value = alt;
        f.appendChild(ia);
      }
    }
  }

  var pend = null;
  function agenda() { if (pend) { clearTimeout(pend); } pend = setTimeout(pintar, 200); }

  function init() {
    pintar();
    setTimeout(pintar, 1200);
    if (!window.MutationObserver) { return; }
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var el = muts[i].addedNodes[j];
          if (el.nodeType !== 1) { continue; }
          if ((el.matches && el.matches('form[action*="/cart/add"]')) ||
              (el.querySelector && el.querySelector('form[action*="/cart/add"]'))) { agenda(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();


/* ============ MOVO NOVO - MEDICION DEL APARTADO ============ */
/* Problema que resuelve: los cuatro botones de apartado escribian la MISMA
   propiedad de linea, asi que al llegar un pedido era imposible saber cual
   superficie lo produjo. Aqui se estampa el origen y se mandan eventos a GA4.

   Dos destinos, a proposito:
   - Atributo de pedido 'Origen': sobrevive al pedido, se ve en el admin y se
     exporta. Es el dato DURO: no depende de que GA4 cargue ni del bloqueador
     de anuncios del cliente.
   - GA4: captura los clics que NO terminan en pedido, que es la diferencia
     entre 'nadie lo ve' y 'todos lo ven pero el pago falla'.

   OJO: /cart/update.js MEZCLA atributos (a diferencia de las propiedades de
   linea, que las reemplaza), asi que escribir Origen no borra Apartado ni Bono. */
(function () {
  var vistos = {};   /* para no repetir la impresion en cada repintado */

  function ga(evento, origen, extra) {
    try {
      if (typeof gtag !== 'function') { return; }
      var d = { superficie: origen, moneda: 'MXN' };
      for (var k in (extra || {})) { d[k] = extra[k]; }
      gtag('event', evento, d);
    } catch (e) {}
  }

  /* Siempre resuelve: la medicion nunca debe bloquear un apartado. */
  window.movoOrigen = function (origen) {
    try {
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Origen': origen } })
      }).catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  };

  window.movoTrack = function (evento, origen, extra) {
    if (evento === 'visto') {
      if (vistos[origen]) { return; }
      vistos[origen] = 1;
      ga('apartado_visto', origen, extra);
      return;
    }
    ga('apartado_click', origen, extra);
    return window.movoOrigen(origen);
  };
})();
